module.exports = __webpack_public_path__ + "static/media/Status_Amarillo.ea5c4dac.svg";